module.exports = __webpack_public_path__ + "img/chevron-right.f5d5201a.svg";